export enum rdePekforcenewsessionEnum {
    No = 0,
    Yes = 1
}

export namespace rdePekforcenewsessionEnum {
    export function values() {
        return Object.keys(rdePekforcenewsessionEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
